<template>
	<FormStep
		:title="$t('components.simulator.title')"
		variant="void"
	>
		<p
			:class="$isMobile() ? 'mb-4 text-body-2' : 'mb-6 text-body-1'"
		>
			{{ $t('components.simulator.start.subtitle') }}
		</p>
		<div
			v-if="logged"
			:class="$isMobile() ? '' : 'd-flex justify-space-between align-end'"
		>
			<VSheet class="w-100 mr-6">
				<AlertWrapper
					outlined
					type="info"
					class="mb-0"
				>
					{{ $t('components.simulator.start.logged.info') }}
				</AlertWrapper>
			</VSheet>
			<VBtn
				width="332"
				color="primary"
				large
				@click="$router.push('/dashboard')"
			>
				{{ $t('components.simulator.start.logged.cta') }}
			</VBtn>
		</div>
		<div v-else>
			<div
				class="d-flex justify-center align-center"
				:class="$isMobile() ? 'mb-4' : 'mb-2'"
			>
				<img
					src="/images/clock-icon.svg"
					alt="clock icon"
					height="40"
					class="mr-2"
				>
				<p class="text-caption mb-0">
					{{ $t('components.simulator.start.info') }}
				</p>
			</div>
			<VBtn
				color="primary"
				large
				class="w-100"
				@click="$emit('next')"
			>
				{{ $t('components.simulator.start.button') }}
			</VBtn>
		</div>
	</FormStep>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import FormStep from '@/components/FormStep/FormStep.vue';
	import { mapState } from 'vuex';

	const Props = Vue.extend({});

	const MixinsDeclaration = mixins(Props);

	@Component({
		components: { FormStep },
		computed: mapState('appState', ['logged', 'user'])
	})
	export default class StartStep extends MixinsDeclaration {}
</script>
